import BaseDataProvider from "./BaseDataProvider";
import { gql } from "apollo-boost";

class GameStatsDataProvider extends BaseDataProvider {
  constructor(client, gamesDataProvider) {
    super(client);
    this.gamesDataProvider = gamesDataProvider;
  }

  async getOne(resource, params) {
    console.log(
      "GameStatsDataProvider.getOne(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    return await this.gamesDataProvider.getOne(resource, params);
  }

  async getList(resource, params) {
    console.log(
      "GameStatsDataProvider.getList(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    return await this.gamesDataProvider.getList(resource, params);
  }

  async delete(resource, params) {
    console.log(
      "GameStatsDataProvider.delete(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    return await this.gamesDataProvider.delete(resource, params);
  }

  async create(resource, params) {
    console.log(
      "GameStatsDataProvider.create(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    return await this.gamesDataProvider.create(resource, params);
  }

  async getManyReference(resource, params) {
    console.log(
      "GameStatsDataProvider.getManyReference(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    return await this.gamesDataProvider.getManyReference(resource, params);
  }

  async update(resource, params) {
    console.log(
      "GameStatsDataProvider.update(" +
        resource +
        "," +
        JSON.stringify(params) +
        ")"
    );
    const objectInfo = JSON.parse(JSON.stringify(params.data));
    delete objectInfo.__typename;
    delete objectInfo.playsBlob;
    delete objectInfo.seasonCode;
    delete objectInfo.sportCode;
    delete objectInfo.location;
    // note that we're just assuming that the input type
    // side-game-input matches the output type. in fact, they
    // don't quite match and we need to delete the players info
    // (which we probably shouldn't be requesting in the first
    // place)
    if (objectInfo.home) {
      delete objectInfo.home.players;
      delete objectInfo.home.__typename;
      delete objectInfo.home.id;
      delete objectInfo.home.season;
      if (objectInfo.home.football) {
        delete objectInfo.home.football.__typename;
        delete objectInfo.home.football.id;
      }
      if (objectInfo.home.girlsvolleyball) {
        delete objectInfo.home.girlsvolleyball.__typename;
        delete objectInfo.home.girlsvolleyball.id;
      }
      if (objectInfo.home.basketball) {
        delete objectInfo.home.basketball.__typename;
        delete objectInfo.home.basketball.id;
      }
      if (objectInfo.home.soccer) {
        delete objectInfo.home.soccer.__typename;
        delete objectInfo.home.soccer.id;
      }
      if (objectInfo.home.baseball) {
        delete objectInfo.home.baseball.__typename;
        delete objectInfo.home.baseball.id;
      }
    }
    if (objectInfo.away) {
      delete objectInfo.away.players;
      delete objectInfo.away.__typename;
      delete objectInfo.away.id;
      delete objectInfo.away.season;
      if (objectInfo.away.football) {
        delete objectInfo.away.football.__typename;
        delete objectInfo.away.football.id;
      }
      if (objectInfo.away.girlsvolleyball) {
        delete objectInfo.away.girlsvolleyball.__typename;
        delete objectInfo.away.girlsvolleyball.id;
      }
      if (objectInfo.away.basketball) {
        delete objectInfo.away.basketball.__typename;
        delete objectInfo.away.basketball.id;
      }
      if (objectInfo.away.soccer) {
        delete objectInfo.away.soccer.__typename;
        delete objectInfo.away.soccer.id;
      }
      if (objectInfo.away.baseball) {
        delete objectInfo.away.baseball.__typename;
        delete objectInfo.away.baseball.id;
      }
    }
    var objectString = JSON.stringify(objectInfo).replace(
      /"(\w+)"\s*:/g,
      "$1:"
    );
    objectString = objectString.substring(1, objectString.length - 1).trim();
    objectString = objectString.replace(
      /gameStatus:"([^"]*)"/,
      "gameStatus:$1"
    );
    objectString = objectString.replace(
      /playoffRound:"([^"]*)"/,
      "playoffRound:$1"
    );
    console.log("GameStatsDataProvider.update():objectString:", objectString);
    const side = `
          id
          season {
            id
            players {
              id
              jerseyNumber
              position
              yearCode
              isActive
              person {
                id
                firstName
                lastName
                name
              }
            }  
            team {
              id
              name
              teamCode
              school {
                name
              }
            }
          }
          football {
            id
            totalPoints
            firstQuarterPoints
            secondQuarterPoints
            thirdQuarterPoints
            fourthQuarterPoints
            overtimePoints
            overtime2Points
            overtime3Points
            passingCompletions
            passingAttempts
            passingYards
            passingTouchdowns
            passingInterceptions
            rushingAttempts
            rushingYards
            rushingTouchdowns
            fumbles
            fumblesLost
            receptions
            receivingYards
            receivingTouchdowns
            fieldGoalsMade
            fieldGoalAttempts
            pointAfterTouchdown
            pointAfterTouchdownAttempts
            pointAfterTouchdownsMade
            interceptionTouchdowns
            pointAfterTouchdownTwoPoints
            returnTouchdowns
            pointAfterTouchdownReturns
            firstDowns
            penalties
            penaltyYards
            pointsAllowed
            puntingYards
            punts
            touchdownPasses
            touchdownReceptions
            totalYards
            yardsAllowed
            puntingAverage
            passingCompletionPercentage
            passingInterceptionYards
            passingAverage
            rushingAverage
            receivingAverage
            fieldGoalYards
          }
          girlsvolleyball {
            id
            game1Points
            game2Points
            game3Points
            game4Points
            game5Points
            finalScore
            kills
            aces
            blocks
            digs
            assists
          }
          basketball {
            id
            totalPoints
            firstQuarterPoints
            secondQuarterPoints
            thirdQuarterPoints
            fourthQuarterPoints
            overtimePoints
            overtime2Points
            overtime3Points
            rebounds
            threePointFieldGoals
          }
          soccer {
            id
            totalPoints
            firstHalfGoals
            secondHalfGoals
            overtimeGoals
            overtime2Goals
            shootouts
            totalGoals
          }
          baseball {
            id
            runs
            hits
            errors
          }`;
    const MUTATION = gql`
          mutation {
            UpdateGame(${objectString}) {
              id
              gameStatus
              gameDateString
              gameTimeString
              gameIsDistrict
              playoffRound
              sportCode
              seasonCode
              playsBlob
              gameStory
              gameStoryIsPublished
              internalNotes
              homeTeamCode
              awayTeamCode
              location {
                id
                stableId
                name
                abbr
              }
              home {
                ${side}
              }
              away {
                ${side}
              }
            }
          }`;
    try {
      const response = await this.client.mutate({ mutation: MUTATION });
      console.log(JSON.stringify(response, null, 2));
      return { data: response.data.UpdateGame };
    } catch (err) {
      console.error(JSON.stringify(err, null, 2));
      return null;
    }
  }
}

export default GameStatsDataProvider;
